import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import EventCardPreview from "./TicketCard";
import { breakdownFromEvent } from "./PriceCalculator";

export default function UpcomingEventsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/Event`
      );
      const data = await response.json();
      setEvents(data);
    };

    fetchEvents();
  }, []);

  if (!events.length) {
    return (
      <div className="text-center text-gray-500 py-20 ">
        {t("Pas d'événement à venir pour le moment!")}
      </div>
    );
  }

  return (
    <div className=" bg-gray-100">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-center mb-6 text-primary">
          {t("ticketing.upcomingEvents")}
        </h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {events.map((event) => (
            <div
              key={event.id}
              className="cursor-pointer hover:shadow-md transition rounded-lg"
              onClick={() => navigate(`/event/${event.id}`)}
            >
              <EventCardPreview
                name={event.name}
                date={event.eventDate}
                location={event.location}
                price={breakdownFromEvent(event).totalPrice.toFixed(2)}
                imageUrl={event.imageUrl}
                isFundraiser={event.isFundraiser}
                taxesIncluded
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
